var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{attrs:{"name":"navigation"}}),_c('router-view',{staticClass:"related-component-container col-sm-10 col-md-8 col-lg-8",attrs:{"name":"related-component"}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }